import styled from "styled-components";

export const Container = styled.button`
  background-color: #46b82f;
  border-radius: 10px;
  height: 40px;
  width: 100%;
  color: white;
  font-size: 18px;
  font-weight: bolder;
  border: none;
  cursor: pointer;
  margin-top: 10px;
`;
